<template>
  <div>
    <div class="page-title">Edit FAQ</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update FAQ"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.faqs.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Faq.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.Faq.update(this.form);
      this.$router.push("/widgets/faqs");
    },
  },
};
</script>

<style></style>
